import { ADD_USER } from 'common/actions';

export const usersReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_USER:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };

    default:
      return state;
  }
};
